/**
 * Quantity Dropdown for products that have the cost expressed in LB(weight)
 *
 * @template <quantity-dropdown-al-v1>
 */

import { Component, Injectable, Input, OnInit, Output, EventEmitter, ElementRef, HostListener, SimpleChanges, OnChanges } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { debounceTime } from 'rxjs/operators';
// Data model
import {  ICart, ISnsInfoObj, IConfigObj } from 'abs-ngx-library/src/lib/core';
import { CommonService, UserInfoService , EnviormentConfig , CartService , CartV2Service, AemService, ProductUtilService, UtilService, QuickAddBasketV1Service } from 'abs-ngx-library/src/lib/core';
import { retry } from 'rxjs/operators';

import {map } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { ToasterALV1Service } from 'abs-ngx-library/src/lib/toaster-al';
import { ToasterType } from 'abs-ngx-library/src/lib/toaster-al';
import { ProductSNSModalALService } from '../product-sns-modal-al/product-sns-modal-al.service';
// Jquery.
declare let $: any;

@Component({
    selector: 'quantity-dropdown-al-v1',
    templateUrl: './quantity-dropdown-al-v1.component.html'
})

@Injectable()
export class QuantityDropdownALV1Component implements OnInit, OnChanges {

    @Input() product: any;
    @Input() sellerId: string;
    @Input() calledBy: string;
    @Input() isAnyProductHasAddlInfo: boolean;
    @Input() noWeightModal: boolean;
    @Input() isRecommended: boolean;
    @Input() isQscV2: boolean;
    @Input() isCheckboxChecked: boolean;
    @Input() snsInfo: ISnsInfoObj;
    @Input() isMkpSellerTagDisabled: boolean;
    @Output() removeMiniCartEmitter = new EventEmitter<Object>();
    @Output() changeMiniCartEmitter = new EventEmitter<Object>();
    @Output() updateUnavailableCountEmitter = new EventEmitter<Object>();
    @Output() setLoadingSpinnerEmitter = new EventEmitter<boolean>();
    @Output() updateCheckboxEmitter = new EventEmitter<void>();
    @Output() updateQscQtyEmitter = new EventEmitter<void>();
    @Input() configObj: IConfigObj;
    public config = EnviormentConfig;
    public reservedTimeIntent: string = '';


    public showWeights = false;
    public showModal = false;
    public previousSelectedWeight = false;
    public weightList = [];
    public estimatedPrice = 0;
    public selectedWeight = 0;
    public currentSelectedWeight = 0;
    public screenSize;
    public isButtonenabled = false;
    public httpOptions;
    public cartId;
    public isWYSIWYGEnabled;
    public addItemToCartAnalytics = false;
    public increaseQuantityAnalytics = false;
    public decreaseItemAnalytics = false;
    public analyticsPreviousPrice;
    public analyticsIsPriceDecreased = false;
    public productDetailPath: string;
    public selectedWeightText = 'Select Weight';
    public SIGNIN = 'Sign in to add';
    public isAuthorized: boolean = false;
    public isQuantityIncreased: boolean = false;
    private imagePath: string = window['AB']['dMTProductCard'];
    private modalTriggeredElement = null;
    public modal = {
       closeBtn: '#modal-est .close',
       modalId: '#modal-est',
       lastFocusableElem: '.amount__add-qty-btn .btn-primary'
   };
   public isExtended: boolean = false;
   public loadingSpinner = false;
    public isOnProductDetail: boolean = false;
   private hasCart: boolean;
   public currentEnv = '';
   private enableAdRelevanceTracking: boolean;
    public toastMessagePostion: string = '29vh';
    private snsInfoChange = new Subject<any>();
    private snsInfoChange$ = this.snsInfoChange.asObservable();
    private subscriptions = new Subscription()
    private entryId: number;


    public constructor(
        private _commonService: CommonService,
        private _userInfoService: UserInfoService,
        private _elementRef: ElementRef,
        public toasterService: ToasterALV1Service,
        private cartService: CartService,
        private _http: HttpClient,
        private cartV2Service: CartV2Service,
        private _aemService: AemService,
        private _productUtilService: ProductUtilService,
        private _utilService: UtilService,
        private _productSnsModalService: ProductSNSModalALService,
        private _quickAddBasketService: QuickAddBasketV1Service
        ) {
            this.isAuthorized = this._userInfoService.isAuthorized();
            this.reservedTimeIntent = this._userInfoService.getUserChannel();
            this.currentEnv = this._commonService.getCurrentEnviorment();
            this.enableAdRelevanceTracking = !this._aemService.getFeatureFlagByNameDisable('disableAdRelevance');

    }

    public ngOnChanges(changes: SimpleChanges): void {

        if(changes.snsInfo && changes.snsInfo.currentValue.updateCart) {
            const qty = this.calledBy === 'minicart' ? this.product.qty : this.product.quantity;
            if(qty > 0) {
                this.snsInfoChange.next({qty: qty, snsInfo: changes.snsInfo});
            }
        }
    };

    ngOnInit() {
       this.isOnProductDetail = this.calledBy === 'product-detail-item';
       this.screenSize = window.innerWidth;

       if (this.isQscV2) {
           this.selectedWeight = this.getSelectedWeight();
           this.selectedWeightText = Number(this.selectedWeight).toFixed(2) + ' lb'
           this.initializeWeightList();
           const cartObjSubscription = this._commonService.currentCartObj.subscribe((cartObj) => {
               const matchingItem = cartObj?.cartItems?.find(item => item.itemId == this.product.id);
               if (matchingItem) {
                   this.processChangesFromCart(matchingItem.selectedWeight);
               }
           })
           this.subscriptions.add(cartObjSubscription);
           return
       }

       if(this.calledBy == 'minicart'){
           this.product['id'] = this.product.itemId;
           this.isButtonenabled = true;
           this.selectedWeight = this.product.selectedWeight ?  this.product.selectedWeight : 0;
           this.weightList = this.product.incrementPriceList ? this.product.incrementPriceList  : [];
           if(this.selectedWeight == this.weightList[this.weightList.length - 1].weight){
               this.selectedWeightText = Number(this.selectedWeight) + ' lb';
           }
           else {
               this.selectedWeightText = Number(this.selectedWeight) + ' lb';
           }
       }
       if (this.calledBy !== 'minicart') {
           let obs = this._commonService.currentCartObj;
           
           const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.sellerId);


           obs = obs.pipe(map(objCart => this.cartV2Service.fetchCartDetailsFromResponse(objCart, cartName)));

           obs.subscribe(objCart => {
               this.hasCart = !!objCart.cartId;

               let qty: any = 0;
               let list: any = [];
               try {
                   let cartProduct: any = {};
                   cartProduct = objCart?.['cartItems']?.find(item => item.itemId == this.product.id);
                   qty = cartProduct ? cartProduct.selectedWeight : 0;
                   list = cartProduct ? cartProduct.incrementPriceList : [];
                   this.entryId = cartProduct?.entryId;
               } catch (e) {
                   qty = 0;
                   list = [];
               }
               this.weightList = list;
               this.selectedWeight = qty;
               
               if (this.selectedWeight != 0) {
                   if(this.selectedWeight == this.weightList[this.weightList.length - 1].weight){
                       this.selectedWeightText = Number(this.selectedWeight) + ' lb';
                   }
                   else {
                       this.selectedWeightText = Number(this.selectedWeight) + ' lb';
                   }
               } else {
                   this.selectedWeightText = 'Select Weight';
               }
           });
       }
       if (this.selectedWeight != 0 && this.screenSize < 1024) {
           this.isButtonenabled = true;
       }

        // Debounce 600ms before sending data to API.
        this.snsInfoChange$.pipe(
            debounceTime(600)
        )
        .subscribe(snsInfoObj => {
            this._cartAPICallV2(snsInfoObj.qty, snsInfoObj.snsInfo);
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any){
        this.screenSize = window.innerWidth;
    }

    public displayWeights(event) {
       if (this.isAuthorized) {
           const preference = this._userInfoService.getPreference()
           ? this._userInfoService.getPreference().toUpperCase()
           : undefined;

           if(preference === 'J4U') {
               window['storeFulfillmentModal'].component.setModalDisplayData(2);
           } else {
               if(this.screenSize >= 1024 || this.noWeightModal) {
                   this.showModal = false;
                   if(this.showWeights) {
                       this.showWeights = false;
                       if(this.selectedWeight !== 0) {
                           this.selectedWeightText = Number(this.selectedWeight).toFixed(2) + ' lb';
                       }
                   } else {
                       if(this.weightList && this.weightList.length > 0) {
                           this.showWeights = true;
                           if(this.selectedWeight !== 0) {
                               this.selectedWeightText = Number(this.selectedWeight).toFixed(2) + ' lb';
                           }
                           this.setADANavigation();
                       } else {
                           this.initializeWeightList();
                           this.setADANavigation();
                       }
                   }
               }
               else{
                   this.displayModal(event);
               }
           }
       }
       else {
            if (window['eddlLoadComplete']) {
                window['AB']['DATALAYER'].setATCFlag(true);
            }
           this._showSignInModal(this.configObj);
       }
    }

    public qscDisplayWeights(event) {
       if (this._userInfoService.getUserChannel() == 'instore') {
           event.preventDefault();
           window['rightDrawerComp'].closeDrawer();
           window['storeFulfillmentModal'].component.setModalDisplayData(2);
           return;
       }

       if (this.screenSize >= 1024) {
           this.showWeights = true;
           this.isExtended = true;
           this.setADANavigation();
       } else {
           this.previousSelectedWeight = true; 
           this.selectedWeight = this.getSelectedWeight()
           this.displayModal(event);
       }

       
      
    }


    /**
    * Show sign in modal to unregistered users.
    */
   private _showSignInModal(configObj?: IConfigObj): void {
    const redirectPath = encodeURIComponent(window.location.href);
        this._aemService.setDomainCookie('ECommRedirectURL', redirectPath, 0);
        if(configObj && configObj?.appName==='weeklyAd'){
            const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
            window.location.assign(bannerDomainUrl + window['AB'].signInLinkPath);
        } else {
            window['AB']['COMMON'].showSignInModal_OTP(window.location.href);
        }
   }

   public qscV2UpdateWeight() {
    this._quickAddBasketService.setQuickAddBasketItemWeight(this.product.id, Number(this.selectedWeight))
   }

   // Logic for modifying quickAddBasket localStorage item and component data on 
   // changes from cart. 
   private processChangesFromCart(weightFromCart: number) {
      this.selectedWeight =  weightFromCart;
      this.selectedWeightText = this.normalizeWeightText(this.selectedWeight);
       // If modal is showing, need to update state using this method. 
       if (this.showModal) {
           this.SelectWeightModal({target: {
               value: weightFromCart
           }})
       }
      this.qscV2UpdateWeight();
   }

    public showPriceChangeToast(isQuantityIncreased: boolean, cart: any) {
        if (isQuantityIncreased && this._commonService.checkPendingOrder()) {
            const orderedProduct = cart['cartItems']?.find(item => item.itemId === this.product.id);
            const price = this._commonService.getValidProductPrice(this.product);
            const orderedItemPrice = orderedProduct?.price < orderedProduct?.basePrice ? orderedProduct?.price : orderedProduct?.basePrice;
            if (orderedProduct && orderedItemPrice !== price) {
                let msg = `Great news—your price for this item is still $${orderedItemPrice}, based on when you placed your order. `;
                this.analyticsPreviousPrice = orderedItemPrice;
                if (orderedItemPrice > price) {
                    msg = `The price for ${this.product.name} has changed, but your price is still $${orderedItemPrice} based on its price on the day your order was placed. `;
                    this.analyticsIsPriceDecreased = true;
                }
                this.toasterService.show({
                    title: 'OK',
                    message: msg,
                    type: ToasterType.Info,
                    interactiveElement: 'See Policy',
                    interactiveElementLink: 'https://www.albertsonscompanies.com/policies-and-disclosures/terms-of-use/default.aspx',
                }, { class: 'popup--toaster--right'});
            }
        }
    }

    public selectWeight(i) {
        if(this.selectedWeight < this.weightList[i].weight) {
            this.isQuantityIncreased = true;
        }
        this.showWeights = false;
        this.selectedWeight = this.weightList[i].weight;
        this.selectedWeightText = this.isQscV2 ? Number(this.selectedWeight).toFixed(2) + ' lb' : Number(this.selectedWeight) + ' lb';
        this.refocusSelectBtn();
        this.isQscV2 ? this.qscV2UpdateWeight() : this.updateWeight(this.selectedWeight);
        if (this.isQscV2) {
           this.isExtended = false;
        }
    }

    public removeSelection() {
        this._removeProductV2();
        this.refocusSelectBtn();
    }

    public qscV2RemoveSelection() {
       this.qscV2RemoveProduct();
       this.showWeights = false;
       this.isExtended = false;
       this.qscV2RefocusSelectBtn();
    }

    private qscV2RemoveProduct() {
        this._quickAddBasketService.setQuickAddBasketSelectedProperty(this.product.id, false);
        this.updateCheckboxEmitter.emit();
    }

    public mouseEnter(i) {
        this.estimatedPrice = this.weightList[i].price;
        setTimeout(()=>{
            $('#dropdown-itm'+i).focus();
        },0);
    }

    public mouseEnterRemoveBtn() {
        this.estimatedPrice = 0;
    }

    public mouseLeave() {
        this.estimatedPrice = 0;
    }

    public refocusSelectBtn() {
        setTimeout(()=>{
            $(`.pid${this.product.id} .quantity-dropdown__btn`).focus();
        },0);
    }

    public qscV2RefocusSelectBtn() {
       setTimeout(()=>{
           $(this._elementRef.nativeElement).children().find("span#qtyDropdownBtn_"+ this.product.id).focus();
       },0);
    }

    public displayModal(event) {
       this.modalTriggeredElement = event.target;
       this.showWeights = false;
       this.showModal = true;
       this.setModalADA();
       this.productDetailPath = this.product?.name && this._commonService.isSeoEnabled() ?
           this._commonService.buildSeoPdpUrl(this.product.fullName || this.product.name, this.product.id) :
           this._commonService.getProductDetailPath();

       if (this.productDetailPath) {
           this.productDetailPath = this.productDetailPath.replace('(bpn)', this.product.id);
       }
       if(this.weightList.length > 0){
           if(this.selectedWeight == 0){
               this.estimatedPrice = this.weightList[0].price;
           }
           else{
               const preWeight = this.selectedWeight;
               this.estimatedPrice = this.weightList.find(item=>item.weight==preWeight).price;
           }
       }
       else{
           this.initializeWeightList();
       }
    }

    private setModalADA() {
       // Set ADA for weighted item modal
       setTimeout(() => {
           const lbvsEach = this;
           $(this.modal.modalId).modal({
               backdrop: 'static',
               keyboard: false,
               show: true
           });
           $(this.modal.modalId).on('shown.bs.modal', function () {
               lbvsEach.modalADA();
           });
           $(this.modal.modalId).on('hidden.bs.modal', function () {
               lbvsEach.modalHideADA();
           });

       }, 0);
    }

   // Sets text to follow format from Figma for Quick Add Web Enhancements
   public normalizeWeightText(weight: number) {
   return Number(weight).toFixed(2) + ' lb';
   }

    private modalADA() {
       const closeBtn = this.modal.closeBtn;
       const modalId = this.modal.modalId;
       const last = this.modal.lastFocusableElem;

       $(modalId).removeAttr('aria-modal');

       let currentElement = $(modalId);
       while (currentElement.length && currentElement.prop("tagName") != "BODY") {
           // Store off the current aria-hidden state, if attribute doesn't exist, use "none"
           let ariaHiddenState = currentElement.attr("aria-hidden");
           if (!ariaHiddenState)
               ariaHiddenState = 'none';

           currentElement.attr("data-aria-state", ariaHiddenState);

           // Set aria-hidden to false (for elements up the parent chain)
           currentElement.attr("aria-hidden", 'false');

           // Iterate over all of the siblings, storing their state and setting aria-hidden to true
           // so that they will not be accessible while the modal is displayed
           currentElement.siblings().each(function() {
               let siblingAriaHiddenState = $(this).attr("aria-hidden");
               if (!siblingAriaHiddenState)
                   siblingAriaHiddenState = 'none';

               $(this).attr("data-aria-state", siblingAriaHiddenState)
               $(this).attr("aria-hidden", 'true');
             });

           currentElement = currentElement.parent();
       }

       $(last).on('keydown keypress', function (e) {
       if ($('this:focus') && e.which === 9) {
           if (closeBtn === last) {
               e.preventDefault();
           } else if (!e.shiftKey) {
               $(closeBtn).focus();
               e.preventDefault();
           }
       }
       });

       $(closeBtn).on('keydown keypress', function (e) {
           if ($('this:focus') && e.which === 9) {
               if (e.shiftKey) {
                   $(last).focus();
                   e.preventDefault();
               }
           }
       });

       // Close modal when ESC is pressed
       const that = this;
       $(modalId).on('keydown', function(e){
           if(e.which == 27 && $(modalId).is(':visible')){
               that.closeModal();
           }
       });

       //Set focus on the close button of the Modal.
       setTimeout(() => {
           $(closeBtn).focus();
       }, 400);
    }

    private modalHideADA() {

       // Find all of the previously saved aria-hidden states and put back
       $("[data-aria-state]").each(function() {
           // Get the saved state and remove the property
           const ariaHiddenState = $(this).attr("data-aria-state");
           $(this).removeAttr('data-aria-state');

           // If the state is set to none, it means it didn't exist so remove it
           if (ariaHiddenState == 'none')
               $(this).removeAttr('aria-hidden');
           else
               $(this).attr('aria-hidden', ariaHiddenState);
         });

       const element = $('#dec_qtyInfo_'+ this.product.id);
       if(element.length > 0) {
           element.focus();
       } else {
           $('#select-weight_'+ this.product.id).focus();
       }
    }

    public SelectWeightModal(event){
        this.currentSelectedWeight = event.target.value;
        this.estimatedPrice = this.weightList.find(item=>item.weight==event.target.value).price;
    }

    public selectedItem(){
       if(!this.previousSelectedWeight){
           return this.weightList[0].weight;
       }
       return this.selectedWeight;
    }

    public finalizeWeight(){
       this.showModal = false;
       this.isButtonenabled = true;
       this.previousSelectedWeight = true;
       if(this.currentSelectedWeight==0){
           this.selectedWeight = this.weightList[0].weight;
       }
       else{
           this.selectedWeight = this.currentSelectedWeight;
       }
       this.currentSelectedWeight = 0;
       this.selectedWeightText = this.isQscV2 ? Number(this.selectedWeight).toFixed(2) + ' lb' :  Number(this.selectedWeight) + ' lb';
       this.isQscV2 ? this._quickAddBasketService.setQuickAddBasketItemWeight(this.product.id, Number(this.selectedWeight)) : this.updateWeight(this.selectedWeight);
       $('#modal-est').modal('hide');
    }

    public decreaseWeight() {
       if(this.selectedWeight == this.weightList[0].weight) {
           if(this.calledBy !== 'minicart') {
               this._removeProductV2();
           } else {
               this._removeMinicart();
           }
       } else {
           const currentWeight = this.selectedWeight;
           const index = this.weightList.findIndex(item=>item.weight==currentWeight);
           this.selectedWeight = this.weightList[index-1].weight;
           this.selectedWeightText = Number(this.selectedWeight) + ' lb';
           this.loadingSpinner = true;
           this.updateWeight(this.selectedWeight);
       }
    }

    private _removeMinicart(){
       this.removeMiniCartEmitter.emit(this.product.id);
    }

    private resetToSelectWeight(){
       this.isButtonenabled = false;
       this.showWeights = false;
       this.selectedWeight = 0;
       this.selectedWeightText = 'Select Weight';
       this.previousSelectedWeight = false;
    }

    public increaseWeight() {
       const currentWeight = this.selectedWeight;
       const index = this.weightList.findIndex(item=>item.weight==currentWeight);
       this.selectedWeight = this.weightList[index+1].weight;
       if(this.selectedWeight == this.weightList[this.weightList.length - 1].weight){
           this.selectedWeightText = Number(this.selectedWeight) + ' lb';
       }
       else {
           this.selectedWeightText = Number(this.selectedWeight) + ' lb';
       }
       this.loadingSpinner = true;
       this.updateWeight(this.selectedWeight);
    }

    public checkIncreaseButtonDisability(){
       if(this.weightList.length > 0) {
           return this.selectedWeight == this.weightList[this.weightList.length - 1].weight;
       }
       return false;
    }

    /**
     * ADA: Sets focus inside quantity stepper with info about in cart quantity.
    */
    private _setFocusInsideQty(): void {

       if (this.calledBy === 'minicart') {
        setTimeout(() => $(this._elementRef.nativeElement).children().find("span#qtyInfo_" + this.product.id).focus(), 0);
       }
    }

    public closeModal() {
       const that = this;

       this.showModal = false;
       $('#modal-est').modal('hide');

       // Set focus back to the stored element that caused the modal to appear
       setTimeout(() => {
           if (that.modalTriggeredElement !== null) {
               that.modalTriggeredElement.focus();
               that.modalTriggeredElement = null;
           }
       }, 100);
    }

    public getImageUrl(id: string, viewport: string): string {
       const modifiedImagePath = this.imagePath;
       return modifiedImagePath ? modifiedImagePath.replace('${product.id}', id).replace('${viewport}', viewport) : '';
   }

    public setADANavigation() {
       //ADA for down arrow navigation
       if(this.weightList && this.weightList.length > 0) {
           setTimeout(()=>{
               const firstItem = "#dropdown-itm0";
               const listItem = ".dropdown-item.est__dropdown--menu--item";
               const removeBtn = ".est__dropdown--menu--item-remove";

               $(firstItem).focus();
               this.estimatedPrice = this.weightList[0].price;

               const that = this;
               $(listItem).on('keydown keypress', function (e) {
                   if ($('this:focus')) {
                       let nextFocusableElement;
                       if(e.which === 40){
                           nextFocusableElement =  $(this).next();
                       } else if (e.which === 38) {
                           nextFocusableElement =  $(this).prev();
                       }

                       if(nextFocusableElement && nextFocusableElement.length && nextFocusableElement.length > 0) {
                           if(!nextFocusableElement.get(0).className.includes("est__dropdown--menu--item-remove")) {
                               const nextIndex = nextFocusableElement.get(0).id.replace("dropdown-itm","");
                               that.estimatedPrice = that.weightList[nextIndex].price;
                           } else if (nextFocusableElement.get(0).className.includes("est__dropdown--menu--item-remove") &&
                                       !nextFocusableElement.get(0).className.includes("est__dropdown--menu--item-remove--disabled")) {
                               that.estimatedPrice = 0;
                           }

                           if(!nextFocusableElement.get(0).className.includes("est__dropdown--menu--item-remove--disabled")) {
                               nextFocusableElement.focus();
                           }
                       }
                   }
               });

               $(removeBtn).on('keydown keypress', function (e) {
                   if ($('this:focus')) {
                       if(e.which === 38) {
                          const element =  $(this).prev();
                          element.focus();
                       }
                   }
               });
           },500);
       }
   }

   public dropdownFocusout(event) {
       const selectWeightBtn = document.getElementById('select-weight_' + this.product.id);

       if (selectWeightBtn) {
           if (!selectWeightBtn.contains(event.relatedTarget)) {
               if(this.selectedWeight !== 0) {
                   this.selectedWeightText = this.isQscV2 ? Number(this.selectedWeight).toFixed(2) + ' lb' : Number(this.selectedWeight) + ' lb';
               }
               this.showWeights = false;
               $(this._elementRef.nativeElement).children().find("span#qtyDropdownBtn_"+ this.product.id).focus();
               if (this.isQscV2) {
                   this.isExtended = false;
               }
           }
       }
   }

    private updateWeight(quantity) {
       this._cartAPICallV2(quantity);
   }

    private _cartAPICallV2(quantity, snsInfoChangeObj?: any) {
       const isCartCreated = !this.hasCart;
       const analyticsProductID = this.product.id || this.product.itemId;
       if (!window['AB']['DATALAYER'].isProductInAnalyticsCart(analyticsProductID)) {
           this.addItemToCartAnalytics = true;
       }
       if(this.calledBy !== 'minicart') {
           this.setLoadingSpinnerEmitter.emit(true);
       }

       this.cartV2Service.addOrUpdateProductQuantity(this.product,
           this.calledBy === 'minicart' ? this.product.itemId : this.product.id, quantity, false, this.sellerId, true, this.snsInfo, this.configObj,
        false, null, this.entryId)
           .subscribe(response => {
               if(response) {
                   if(this.isQuantityIncreased) {
                       this.showPriceChangeToast(this.isQuantityIncreased, response);
                       this.isQuantityIncreased = false;
                   }
                   this.cartService.refreshCart(response);
                   this.loadingSpinner = false;
                   const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.sellerId);
                   let singleCartresponse :ICart=  this.cartV2Service.fetchCartDetailsFromResponse(response, cartName);
                   if (singleCartresponse && singleCartresponse['cartId']) {
                       if(this.calledBy !== 'minicart'){
                           this.setLoadingSpinnerEmitter.emit(false);
                       }
                       if (singleCartresponse['cartItems']) {   
                           this._commonService.sendSponsoredProductClickEvent(this.product, 'quantityDropdown', 'qtyChange');
                           //call relevance call only if product added for first time
                           if(this.enableAdRelevanceTracking){
                            this._commonService.recordRelevanceImpression(this.product, 'quantityDropdown', 'qtyChange');
                            }
                           singleCartresponse = this.cartV2Service.handleResponseForPendingOrder(singleCartresponse);
   
                           this.cartId = singleCartresponse['cartId'];
   
                           setTimeout(() => {
                               this._setFocusInsideQty();
                           }, 1000);
   
                           this._setFocusInsideQty();
                           this.product.quantity = quantity;
                           // Emit new cart summary to minicart
                           if (this.calledBy === 'minicart') {
                               this.changeMiniCartEmitter.emit(singleCartresponse['summary']);
                               this.updateUnavailableCountEmitter.emit(singleCartresponse['mfcUnavailableProductsCount']);
                           }
                           this.isWYSIWYGEnabled = singleCartresponse['isWYSIWYGEnabled'];
   
                            if(this.isOnProductDetail && snsInfoChangeObj &&
                                (snsInfoChangeObj?.currentValue?.isChecked !== snsInfoChangeObj?.previousValue?.isChecked) &&
                                snsInfoChangeObj?.currentValue?.isChecked  === false
                                ) {
                                this.toasterService.show({
                                  title: 'OK',
                                  message: `You've unsubscribed to this item.`,
                                  type: ToasterType.Info,
                                  interactiveElement: 'Undo'
                                }, { top: this.toastMessagePostion});
                            }

                           if (window['AB']['DATALAYER']) {
                                const sellerId = this.sellerId ? this.sellerId : singleCartresponse['cartCategory'] === '1P_WINE' ? '22222222' : window['AB']['DATALAYER'].getBannerSellerId();
                                window['AB']['DATALAYER'].updateCartType(this.calledBy === 'minicart' ? 'mini_cart' : '');
                                window['AB']['DATALAYER'].updateCart(response, this.product, response['isWYSIWYGEnabled']);
                                if (!this.addItemToCartAnalytics) {
                                   if (window['AB']['DATALAYER'].weightSelectionActionType(analyticsProductID, this.product.quantity) === 'increase') {
                                       this.increaseQuantityAnalytics = true;
                                   } else if (window['AB']['DATALAYER'].weightSelectionActionType(analyticsProductID, this.product.quantity) === 'decrease') {
                                       this.decreaseItemAnalytics = true;
                                   }
                                }
                               this._updateAnalyticsProductInfo(this.product.quantity, sellerId);
                               if (this.addItemToCartAnalytics) {
                                   window['AB']['DATALAYER'].addItemToCart();
                                   this.addItemToCartAnalytics = false;
                               } else if (this.increaseQuantityAnalytics) {
                                   window['AB']['DATALAYER'].increaseItemQuantity();
                                   this.increaseQuantityAnalytics = false;
                               } else if (this.decreaseItemAnalytics) {
                                   window['AB']['DATALAYER'].decreaseItemQuantity();
                                   this.decreaseItemAnalytics = false;
                               }
                           }
                       }
                   }
               }

            }, err => {
                console.error('Error while calling Cart API: ' + err.message);
                if(this.isOnProductDetail && snsInfoChangeObj &&
                    (snsInfoChangeObj?.currentValue?.isChecked !== snsInfoChangeObj?.previousValue?.isChecked) 
                    ) {
                   const modalDataConfig = {
                        modal: 'errorModal',
                        showModal: true,
                        prevIdToFocus: '',
                        errModalType: snsInfoChangeObj.currentValue.isChecked ? 'subscribe' :  'unsubscribe',
                        selectedFrequency :this.snsInfo.selectedFrequency
                    }
                    this._productSnsModalService.show(modalDataConfig);
                }
                this.loadingSpinner = false;
                this.isQuantityIncreased = false;
            });
    }

    private _removeProductV2(): void {
        this.setLoadingSpinnerEmitter.emit(true);
        this.cartV2Service.removeProduct(
            this.product,
            this.calledBy === 'minicart' ? this.product.itemId : this.product.id,
            this.sellerId, this.configObj, false, this.entryId
        ).subscribe((response: any) => {
           if(response) {
               this.cartService.refreshCart(response);
               const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.sellerId);
               let singleCartresponse =  this.cartV2Service.fetchCartDetailsFromResponse(response, cartName);

               this.loadingSpinner = false;
               this.setLoadingSpinnerEmitter.emit(false);
               this._commonService.sendSponsoredProductClickEvent(this.product, 'quantityDropdown', 'removeProduct');
  
               if(this._commonService.checkPendingOrder() && !this._aemService.getEditOrderOldVersion()) {
  
                   const order = {
                       ...singleCartresponse
                   };
  
                   if (order.hasOwnProperty('orderSummary')) {
                       delete order['orderSummary'];
                   }
  
                   singleCartresponse = {
                       ...order,
                       totalAmount: singleCartresponse['orderSummary'] ? singleCartresponse['orderSummary']['totalEstimatedPrice'] : null,
                       subscriptionDetails: singleCartresponse['orderSummary'] ? singleCartresponse['orderSummary']['subscriptionDetails'] : null,
                       totalOfferSavings: singleCartresponse['orderSummary'] ? singleCartresponse['orderSummary']['totalSavings'] : null,
                       payments: singleCartresponse['payments'] && singleCartresponse['payments'].length ? order['payments'].map(payment => {
  
                           // subType needs to change the key name to subtype
                           const subtype = payment.subType;
                           delete payment.subType;
  
                           return {
                               ...payment,
                               subtype
                           };
  
                       }) : singleCartresponse['payments'],
                       orderSummary: {
                           ...singleCartresponse['orderSummary']
                       },
                       isWYSIWYGEnabled: singleCartresponse['isWYSIWYGEnabled'],
                       wysiwygOrderSummary: {
                           ...singleCartresponse['wysiwygOrderSummary']
                       }
                   };
               }

               singleCartresponse = this.cartV2Service.handleResponseForPendingOrder(singleCartresponse);
  
               this.isWYSIWYGEnabled = singleCartresponse['isWYSIWYGEnabled'];
  
               if (window['AB']['DATALAYER']) {
                    const sellerId = this.sellerId ? this.sellerId : singleCartresponse['cartCategory'] === '1P_WINE' || cartName === '1P_WINE' ? '22222222' : window['AB']['DATALAYER'].getBannerSellerId();
                    window['AB']['DATALAYER'].updateCartType(this.calledBy === 'minicart' ? 'mini_cart' : '');
                    window['AB']['DATALAYER'].updateCart(response, null, response['isWYSIWYGEnabled']);
                    this._updateAnalyticsProductInfo(0, sellerId);
                    window['AB']['DATALAYER'].removeItemFromCart();
               }
  
               console.error('Cart API is succesful with no response');
               this.resetToSelectWeight();
               this.loadingSpinner =false;
           }
        }, err => {
            console.error('Error while calling Cart API: ' + err.message);
            this.loadingSpinner = false;
        });
    }

    public initializeWeightList() {
        
       const catalogConfig = this.config[this.currentEnv]?.catalogConfig
       this.httpOptions = {
           headers: new HttpHeaders({
               'Content-Type': 'application/json',
               'ocp-apim-subscription-key': catalogConfig['apim.api.brand.index.service.key']
           })
       };

       const incrementPriceList = catalogConfig['apim.api.catalog.path']
                               + catalogConfig['apim.api.catalog.increment.price.list.endpoint']
                               + `?upcIds=${this.product.upc}&storeId=${this._userInfoService.getShopStoreId()}`;

       this._http.get(incrementPriceList, this.httpOptions)
                   .pipe(retry(1))
                   .subscribe(response => {
                       if(response) {
                           const priceAndPromoResponse = response['priceAndPromoResponse'];
                           if(priceAndPromoResponse && priceAndPromoResponse.length > 0) {
                               if(this.showModal) {
                                   this.weightList = priceAndPromoResponse[0]['incrementPriceList'];
                                   this.selectedWeight = this.weightList[0].weight;
                                   this.estimatedPrice = this.weightList[0].price;
                               }
                               else {
                                   this.weightList = priceAndPromoResponse[0]['incrementPriceList'];
                                   if(this.weightList && this.weightList.length > 0){
                                       this.showWeights = true;
                                   }
                               }
                           }
                           if(this.isQscV2) {
                               this.showWeights = false;
                           }
                       }
                   }, err => {
                       this.showWeights = false;
                       this.loadingSpinner = false;
                   });
    }

    /**
    * Update analytics product info.
    */
   private _updateAnalyticsProductInfo(selectedWeight: any, sellerId?: any): void {
       // check for datalayer availability, in case component is loaded on pages without the AEM datalayer
       if (window['AB']?.DATALAYER) {
           let carouselTitle = '';
           const isCrossSell = false;
           const isBIACrossSell = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelectorAll('[data-carousel-behaviour="bia-crossSell"]')?.length;
           const isBIASpaCarousel = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelectorAll('[data-carousel-behaviour="bia-spaCarousel"]')?.length;
           if (isBIACrossSell) {
               carouselTitle = this._elementRef.nativeElement.closest('cross-sell')?.querySelector('.cross-sell__header .cross-sell__title')?.textContent;
           } else if (isBIASpaCarousel) {
               carouselTitle = this._elementRef.nativeElement.closest('.bia-spa-carousel-container')?.querySelector('.bia-spa-carousel-container-header')?.textContent?.trim();
           } else if (this._elementRef.nativeElement.closest('.master-product-carousel')) {
               carouselTitle = this._elementRef.nativeElement.closest('.master-product-carousel').querySelector('[data-carousel-title]')?.getAttribute('data-carousel-title');
           } else if (window['AB'].DATALAYER.isDFTAPage()) {
               carouselTitle = this._elementRef.nativeElement.closest('.slick-product-carousel')?.previousElementSibling?.textContent?.trim() || '';
           } else {
               carouselTitle = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('lazy-wrapper')?.getAttribute('data-carousel-title') || 
               this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('.carousel-header-text')?.textContent?.trim() || this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('targeted-wrapper')?.getAttribute('data-carousel-title');
           }
           const productInfoObj: any = {
               id: this.product.id || this.product.itemId,
               adobeMetricA: this.product['adobeMetrics']?.metricA,
               adobeMetricC: this.product['adobeMetrics']?.metricC,
               fullName: this.product.fullName,
               name: this.product.name,
               units: window['AB'].COMMON.checkPendingOrder() ? this.product.quantity : this.product.qty,
               unitType: this.product.unitQuantity,
               lbs: '0',
               each: '0',
               pricePerUnit: this.product.pricePer,
               listPrice: this.product.price ? this.product.price.toString() : '',
               carouselSection: carouselTitle,
               basePrice: this.product.basePrice ? this.product.basePrice.toString() : '',
               pricingType: this.product.promoType,
               couponFlag: '0',
               couponClipped: '0',
               couponID: '',
               aisleId: this.product.aisleId,
               upc: this.product.upc,
               isMTO: this.product.isMtoProduct,
               departmentName: this.product.departmentName,
               sellerId: sellerId ? sellerId : this.product.sellerId,
               sellerName: this.product.sellerName,
               editOrderFlow: this._commonService.checkPendingOrder() ? true : false,
               snapEligible: this.product.snapEligible,
               isProductTrackingDisabled: this.product.isProductTrackingDisabled ? true : false,
               isP13nGrid: this._elementRef.nativeElement.closest('#p13nProductGrid') ? true : false,
               quantity: this.product.quantity,
               previousPrice: this.analyticsPreviousPrice,
               isPriceDecreased: this.analyticsIsPriceDecreased,
               badges: this.product.badges,
               containsAlcohol: this.product.containsAlcohol,
               featured: this.product.featured
           };
           if (this.product.unitQuantity == 'LB') {
               productInfoObj.lbs = selectedWeight;
           } else if (this.product.unitQuantity == 'EACH') {
               productInfoObj.each = this.product.quantity ? this.product.quantity : this.product.qty;
           }

            //TODO: Analytics team should make changes here to not consume coupons from local storage
           const coupons = [];
           // If there are coupons present on the product, filters the information and adds it to the productInfo object
           if (coupons.length > 0) {
               const couponsClipped = coupons.filter(x => x.status === 'C').length;
               const couponsCount = coupons.length;
               const couponIds = coupons.filter(x => x.status === 'C').map(x => x.offerId).toString();

               productInfoObj.couponFlag = couponsCount.toString();
               productInfoObj.couponClipped = couponsClipped.toString();
               productInfoObj.couponID = couponIds;
           }
           // For items that are not on the minicart, set the recommendation type to be used in analytics code
           if (this.calledBy !== 'minicart') {
               let isBuyItAgain;
               let isBrPathway;
               let isPicksForYou = false;
               let isP13nGeneric = false;
               if (carouselTitle) {
                   const parentCarousel = $(this._elementRef.nativeElement).closest('.slick-product-carousel');
                   const buyItAgainCarousel = parentCarousel.find('[data-carousel-behaviour=buy-it-again]').length;
                   const brPathwayCarousel = parentCarousel.find('[data-carousel-driven=pathway-search]').length;
                   const p13nGenericCarousel = parentCarousel.find('[data-carousel-driven=p13n-generic]').length;
                   productInfoObj.isBIACarousalProduct = parentCarousel.find('[data-carousel-behaviour=bia-spaCarousel]').length ? true : false;
                   isBuyItAgain = buyItAgainCarousel ? true : false;
                   isBrPathway = brPathwayCarousel ? true : false;
                   isPicksForYou = carouselTitle.search(/picks for you|picked for you|picks-for-you|picked-for-you/i) !== -1;
                   isP13nGeneric = p13nGenericCarousel ? true : false;
                    // set placement value for carousel items
                    productInfoObj.placement = window['AB'].DATALAYER.setPlacementInfoCarouselItems(this._elementRef.nativeElement);
               }
               const recommendationObj = {
                   isCrossSell: isCrossSell,
                   isRecommended: this.isRecommended || isPicksForYou || isP13nGeneric,
                   isSponsored: this.product['featured'],
                   isPastPurchased: isBuyItAgain || this.product['pastPurchased'],
                   isBrPathway: isBrPathway
               };
               if (this.product['adId']||this.product.eventTracking) {
                   recommendationObj.isSponsored = true;
               }
               window['AB'].DATALAYER.recommendationInfo(recommendationObj);
           }
           window['AB'].DATALAYER.productInfo(productInfoObj);

           /**
            * update pageFilter with:
            * cart type (when a user performs a product action in mini cart)
            * carousel title (when a user performs any action related to a carousel)
            */
           if (this.calledBy === 'minicart') {
               window['AB'].DATALAYER.setCarouselName('shop|mini_cart');
           } else if (carouselTitle) {
               window['AB'].DATALAYER.isRecipesPage()
                   ? window['AB'].DATALAYER.setCarouselName(`recipes|${carouselTitle}`)
                   : window['AB'].DATALAYER.setCarouselName(`shop|${carouselTitle}`);
           } else {
               window['AB'].DATALAYER.setCarouselName('');
           }

           /**
            * for products that are not in the minicart or in a carousel
            * set metaInfo(number of images clicked on pdp before the user performs a product action)
            */
           if (window['AB'].DATALAYER.isPdp()) {
               if (this.calledBy === 'minicart' || carouselTitle) {
                   window['AB'].DATALAYER.setPageFilterMetaInfo(false);
               } else {
                   window['AB'].DATALAYER.setPageFilterMetaInfo(true);
               }
           }
       }
   }

   /**
    * Generate Dynamic aria-lable for accessibility
    */
   public getAriaLabel(weight: any){
       return `Estimated Total $${this.estimatedPrice}. Weight selected is ${Math.round(weight * 100) / 100} lb`;
   }
   /**
    * Returns the selected weight property of the matching item in quickAddBasket.
    */
   private getSelectedWeight():number {
       return parseFloat(this._quickAddBasketService.getQuickAddBasketItemWeight(this.product.id));
   }

   ngOnDestroy() {
    this.subscriptions.unsubscribe();
   }
}
